import { Select } from 'antd';
import { useDebounce } from '@/hooks';
import { PAGE_SIZE_OPTIONS } from '@/shared/constants';

export function PageSizeDropdown({
  data,
  page,
  status,
  pageSize,
  handleTableChange,
  ...rest
}) {
  const onChange = useDebounce((newPageSize) => {
    const totalPages = Math.ceil(data.length / newPageSize);
    const newPage = page > totalPages ? totalPages : page;

    handleTableChange({ current: newPage, pageSize: newPageSize });
  }, 300);

  if (status === 'pending') {
    return <div className="h-8 w-16 animate-pulse rounded-md bg-white" />;
  }

  if (status === 'error') {
    return null;
  }

  return (
    <Select
      className="w-16"
      value={Number.isFinite(pageSize) ? pageSize : 10}
      options={PAGE_SIZE_OPTIONS}
      onChange={onChange}
      {...rest}
    />
  );
}
